import React from 'react';
import { useNavigate } from 'react-router-dom';
import LegalPageLayout from './LegalPageLayout';
import stepOne from './assets/how-to-play/step-1-screenshot.png';
import stepTwo from './assets/how-to-play/step-2-screenshot.png';
import stepThree from './assets/how-to-play/step-3-screenshot.png';
import stepFour from './assets/how-to-play/step-4-screenshot.png';
import './HowToPlay.css';

function HowToPlay() {
	const navigate = useNavigate();

	return (
		<LegalPageLayout title="How to Play">
			<div className="how-to-play-instructions">
				<div className="instruction-card">
					<div className="instruction-header">
						<span className="instruction-step">1</span>
						<span className="instruction-title">Start with the first clue</span>
					</div>
					<p>Use the sketch and quote audio to make your best first guess. Enter the movie title in the input field and press Submit.</p>
					<img src={stepOne} alt="Step 1 screenshot: first clue" />
				</div>
				<div className="instruction-card">
					<div className="instruction-header">
						<span className="instruction-step">2</span>
						<span className="instruction-title">Incorrect guesses unlock more</span>
					</div>
					<p>Each wrong guess reveals the next quote, giving you a fresh hint. Under the input field, you will see the previous guesses you made.</p>
					<img src={stepTwo} alt="Step 2 screenshot: next clue unlocked" />
				</div>
				<div className="instruction-card">
					<div className="instruction-header">
						<span className="instruction-step">3</span>
						<span className="instruction-title">Skip when you’re stuck</span>
					</div>
					<p>Leave the input blank and press Submit to move ahead without guessing.</p>
					<img src={stepThree} alt="Step 3 screenshot: skip a clue" />
				</div>
				<div className="instruction-card">
					<div className="instruction-header">
						<span className="instruction-step">4</span>
						<span className="instruction-title">Solve within six attempts</span>
					</div>
					<p>Guess the movie title in six tries (or fewer) to win the daily puzzle.</p>
					<img src={stepFour} alt="Step 4 screenshot: solve within six attempts" />
				</div>
			</div>
			<div className="how-to-play-home">
				<button type="button" className="how-to-play-home-button" onClick={() => navigate('/')}>
					Home
				</button>
			</div>
		</LegalPageLayout>
	);
}

export default HowToPlay;
